import { MenuItemEnum, SidebarModelResponse } from 'src/models/Partner/Sidebar';
import i18next, { TOptions } from 'i18next';
import { isAbsoluteUrl } from 'src/utils/url';

// inner React links
export const sidebarSpaLinks = [
  MenuItemEnum.MyCampaigns,
  MenuItemEnum.DonationPages,
  MenuItemEnum.StartGuide,
  MenuItemEnum.Administration,
  MenuItemEnum.PartnerAdministration,
  MenuItemEnum.Users,
  MenuItemEnum.SupporterCenter,
  MenuItemEnum.Integrations,
  MenuItemEnum.Funding,
  MenuItemEnum.Branding,
  MenuItemEnum.Profile,
  MenuItemEnum.Supporters,
  MenuItemEnum.EmailMarketing,
  MenuItemEnum.OrganizationPricing,
  MenuItemEnum.OrganizationReports,

  MenuItemEnum.LiveEventManagement,
  MenuItemEnum.CampaignManagement,
  MenuItemEnum.AddInPersonEventItemsToBalance,
  MenuItemEnum.CheckInAttendees,
  MenuItemEnum.ViewInPersonEventRunningDonors,
  MenuItemEnum.ViewInPersonFundANeed,
  MenuItemEnum.ViewInPersonEventLiveAuction,
  MenuItemEnum.ViewInPersonEventPaddleRaiseDonations,
  MenuItemEnum.EnterRafflePhysicalTickets,
  MenuItemEnum.ManageRaffleWinners,
  MenuItemEnum.EnterSweepstakesPhysicalTickets,
  // MenuItemEnum.ManageSweepstakesWinners,
];

export const sidebarTestIds: Record<number, string> = {
  [MenuItemEnum.MyCampaigns]: 'campaignsLeftMenu',
  [MenuItemEnum.NewCampaign]: 'newCampaignLeftMenu',
  [MenuItemEnum.Branding]: 'brandingLeftMenu',
  [MenuItemEnum.Profile]: 'profileLeftMenu',
  [MenuItemEnum.Funding]: 'paymentProcessingLeftMenu',
  [MenuItemEnum.Integrations]: 'integrationsLeftMenu',
  [MenuItemEnum.Users]: 'userManagementLeftMenu',
  [MenuItemEnum.SupporterCenter]: 'supporterCenterLeftMenu',
  [MenuItemEnum.DonationPages]: 'donationPagesLeftMenu',
  [MenuItemEnum.HelpCenter]: 'helpCenterLeftMenu',
  [MenuItemEnum.StartGuide]: 'startGuideLeftMenu',
  [MenuItemEnum.Settings]: 'settingsLeftMenu',
  [MenuItemEnum.Administration]: 'administrationLeftMenu',
  [MenuItemEnum.PartnerAdministration]: 'partnerAdministrationLeftMenu',
  [MenuItemEnum.SwitchAccount]: 'switchOrganizationLeftMenu',
  [MenuItemEnum.Supporters]: 'supportersLeftMenu',
  [MenuItemEnum.EmailMarketing]: 'emailMarketingLeftMenu',
  [MenuItemEnum.OrganizationReports]: 'reportingLeftMenu',
  [MenuItemEnum.PlusSubscriptionBilling]: 'billingLeftMenu',
  [MenuItemEnum.OrganizationPricing]: 'pricingLeftMenu',
  [MenuItemEnum.PledgeFunding]: 'pledgeFundingLeftMenu',
  [MenuItemEnum.CampaignManagement]: 'campaignManagement',
  [MenuItemEnum.LiveEventManagement]: 'liveEventLeftMenu',
  [MenuItemEnum.AddInPersonEventItemsToBalance]: 'addItemToDeb',
  [MenuItemEnum.CheckInAttendees]: 'ticketingQrCode',
  [MenuItemEnum.ViewInPersonEventRunningDonors]: 'manageEventBalances',
  [MenuItemEnum.ViewInPersonFundANeed]: 'fundNeedLeftMenu',
  [MenuItemEnum.ViewInPersonEventLiveAuction]: 'liveAuctionLeftMenu',
  [MenuItemEnum.ViewInPersonEventPaddleRaiseDonations]: 'paddleRaiseLeftMenu',
  [MenuItemEnum.EnterRafflePhysicalTickets]: 'outsideEntriesLeftMenu',
  [MenuItemEnum.DrawRaffleWinners]: 'drawWinnersLeftMenu',
  [MenuItemEnum.ManageRaffleWinners]: 'manageWinnersLeftMenu',
  [MenuItemEnum.EnterSweepstakesPhysicalTickets]: 'outsideEntriesLeftMenu',
  [MenuItemEnum.DrawSweepstakesWinners]: 'drawWinnersLeftMenu',
  [MenuItemEnum.ManageSweepstakesWinners]: 'manageWinnersLeftMenu',
  [MenuItemEnum.EnterActivityResults]: 'activityResultsLeftMenu',
  [MenuItemEnum.ViewStreamManager]: 'livestreamLeftMenu',
};

export const sideBarGlobalItemsIds = [
  MenuItemEnum.MyCampaigns,
  MenuItemEnum.Supporters,
  MenuItemEnum.EmailMarketing,
  MenuItemEnum.OrganizationReports,
  MenuItemEnum.HelpCenter,
];

export const sideBarSettingsItemsIds = [
  MenuItemEnum.Branding,
  MenuItemEnum.Profile,
  MenuItemEnum.Funding,
  MenuItemEnum.OrganizationPricing,
  MenuItemEnum.Integrations,
  MenuItemEnum.Users,
  MenuItemEnum.DonationPages,
  MenuItemEnum.PlusSubscriptionBilling,
  MenuItemEnum.SupporterCenter,
];

export const sideBarCampaignOptionsMainIds = [MenuItemEnum.CampaignManagement, MenuItemEnum.LiveEventManagement];

export const sideBarCampaignOptionsQuickLinksIds = [
  MenuItemEnum.AddInPersonEventItemsToBalance,
  MenuItemEnum.CheckInAttendees,
  MenuItemEnum.ViewInPersonEventRunningDonors,
  MenuItemEnum.ViewInPersonFundANeed,
  MenuItemEnum.ViewInPersonEventLiveAuction,
  MenuItemEnum.ViewInPersonEventPaddleRaiseDonations,
];

export const sideBarCampaignOptionsOtherQuickLinksIds = [
  MenuItemEnum.EnterRafflePhysicalTickets,
  MenuItemEnum.DrawRaffleWinners,
  MenuItemEnum.ManageRaffleWinners,
  MenuItemEnum.EnterSweepstakesPhysicalTickets,
  MenuItemEnum.DrawSweepstakesWinners,
  MenuItemEnum.ManageSweepstakesWinners,
  MenuItemEnum.EnterActivityResults,
  MenuItemEnum.ViewStreamManager,
];

const translate = (str: string, options?: TOptions) => i18next.t(`leftMenu.${str}`, options);

export const sidebarGetTitleItem = (id: MenuItemEnum, defaultTitle: string | null) => {
  const titles: Record<number, string> = {
    [MenuItemEnum.MyCampaigns]: translate('myExperiences'),
    [MenuItemEnum.NewCampaign]: translate('createExperience'),
    [MenuItemEnum.Branding]: translate('branding'),
    [MenuItemEnum.Profile]: translate('profile'),
    [MenuItemEnum.Funding]: translate('funding'),
    [MenuItemEnum.Integrations]: translate('integrations'),
    [MenuItemEnum.Users]: translate('users'),
    [MenuItemEnum.SupporterCenter]: translate('supportCenter'),
    [MenuItemEnum.DonationPages]: translate('donationList'),
    [MenuItemEnum.HelpCenter]: translate('helpCenter'),
    [MenuItemEnum.StartGuide]: translate('startGuide'),
    [MenuItemEnum.Administration]: translate('administration'),
    [MenuItemEnum.PartnerAdministration]: translate('administration'),
    [MenuItemEnum.SwitchAccount]: translate('switchAccount'),
    [MenuItemEnum.Supporters]: translate('supporters'),
    [MenuItemEnum.EmailMarketing]: translate('emailMarketing'),
    [MenuItemEnum.PlusSubscriptionBilling]: translate('billing'),
    [MenuItemEnum.OrganizationPricing]: translate('pricing'),
    [MenuItemEnum.PledgeFunding]: translate('pledgeFunding'),
    [MenuItemEnum.Settings]: translate('settings'),
    [MenuItemEnum.OrganizationReports]: translate('reports'),
    [MenuItemEnum.CampaignManagement]: translate('campaignManagement'),
    [MenuItemEnum.LiveEventManagement]: translate('liveEventManagement'),
    [MenuItemEnum.AddInPersonEventItemsToBalance]: translate('addInPersonEventItemsToBalance'),
    [MenuItemEnum.CheckInAttendees]: translate('checkInAttendees'),
    [MenuItemEnum.ViewInPersonEventRunningDonors]: translate('viewInPersonEventRunningDonors'),
    [MenuItemEnum.ViewInPersonFundANeed]: translate('viewInPersonFundANeed'),
    [MenuItemEnum.ViewInPersonEventLiveAuction]: translate('viewInPersonEventLiveAuction'),
    [MenuItemEnum.ViewInPersonEventPaddleRaiseDonations]: translate('viewInPersonEventPaddleRaiseDonations'),
    [MenuItemEnum.EnterRafflePhysicalTickets]: translate('enterRafflePhysicalTickets'),
    [MenuItemEnum.DrawRaffleWinners]: translate('drawRaffleWinners'),
    [MenuItemEnum.ManageRaffleWinners]: translate('manageRaffleWinners'),
    [MenuItemEnum.EnterSweepstakesPhysicalTickets]: translate('enterSweepstakesPhysicalTickets'),
    [MenuItemEnum.DrawSweepstakesWinners]: translate('drawSweepstakesWinners'),
    [MenuItemEnum.ManageSweepstakesWinners]: translate('manageSweepstakesWinners'),
    [MenuItemEnum.EnterActivityResults]: translate('enterActivityResults'),
    [MenuItemEnum.ViewStreamManager]: translate('viewStreamManager'),
  };

  return defaultTitle || titles[id] || '';
};

export type MenuItemProps = {
  id: MenuItemEnum;
  title: string;
  url: string;
  readyAsSPA: boolean;
  openNewTab: boolean;
  testId: string;
};

export const getMenuItem = (
  id: MenuItemEnum,
  items: SidebarModelResponse['MenuItems'],
  organizationId: string
): MenuItemProps | null => {
  const foundItem = items.find(({ ID }) => ID === id);

  if (foundItem) {
    return {
      id,
      title: sidebarGetTitleItem(id, foundItem.Title),
      url: foundItem.Url.replace(':id', organizationId),
      readyAsSPA: sidebarSpaLinks.includes(id),
      openNewTab: isAbsoluteUrl(foundItem.Url),
      testId: sidebarTestIds[id],
    };
  }

  return null;
};

export const getMenuItems = (
  itemsIds: MenuItemEnum[],
  items: SidebarModelResponse['MenuItems'],
  organizationId: string
) =>
  itemsIds.reduce<MenuItemProps[]>((acc, id) => {
    const menuItem = getMenuItem(id, items, organizationId);

    if (menuItem) {
      acc.push(menuItem);
    }

    return acc;
  }, []);
